import React from "react";

const GOLD = "#ebb51b";
const GRAY = "#9a9ca1";

export const OrderMonitoringIcon = ({
  size = 28,
  className = "",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Monitor */}
      <rect
        x="7"
        y="10"
        width="50"
        height="35"
        rx="5"
        stroke={GOLD}
        strokeWidth="4"
      />

      {/* Pacco */}
      <rect
        x="22"
        y="18"
        width="20"
        height="16"
        rx="2"
        fill={GOLD}
      />

      {/* Nastro pacco */}
      <rect
        x="29"
        y="18"
        width="6"
        height="8"
        fill={GRAY}
      />

      {/* Linea monitoraggio */}
      <path
        d="M15 38H22L26 33L31 39L36 35L41 38H49"
        stroke={GRAY}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Piedistallo */}
      <path
        d="M26 45V51"
        stroke={GRAY}
        strokeWidth="4"
        strokeLinecap="round"
      />

      <path
        d="M38 45V51"
        stroke={GRAY}
        strokeWidth="4"
        strokeLinecap="round"
      />

      <path
        d="M21 53H43"
        stroke={GOLD}
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default OrderMonitoringIcon;